import React, { Component } from 'react'
import Toolbar from '@material-ui/core/Toolbar';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { currentScrollingPage } from "../../constants/index";
import Grid from '@material-ui/core/Grid';
import { Box, IconButton } from "@material-ui/core";
import PropTypes from 'prop-types';
import AppBar from "@material-ui/core/AppBar";

import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSort,
    faSortAlphaDown,
    faSortAlphaUpAlt,
    faSortNumericDown,
    faSortNumericUpAlt
} from "@fortawesome/free-solid-svg-icons";

//Actions
import {
    GetDiagnosticReportSort,
    ExportDiagnostic
} from '../../actions/diagnosticReportAction';

import { getCommunityByIdAsync, getAllCommunities } from '../../actions/communityActions';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';

import DiagnosticFiltersDrawer from "../../views/community/DiagnosticFiltersDrawer";


const initFilters = {
    dateChanged: false,
    dateOptionSelected: '',
    startDate: new Date(),
    endDate: new Date(),
    mealsSelected: [],
    tagsSelected: []
}

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};



export class DiagnosticReport extends Component {
    constructor(props) {
        super();
        this.state = {
            isLoading: false,
            diagnosticReports: [],
            currentPage: currentScrollingPage,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //RenderNedded
            openCommunityCombo: false,
            filterObj: undefined,
            openFilters: false,
            AnchorElId: undefined,

            sortColumn: 'lowerName',
            sortDesc: true
        };
        this.observer = React.createRef();
        this.lastDiagnosticRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), async () => {
                        await this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                    });
                }
            });
            if (node) this.observer.current.observe(node)
        }
    }

    componentDidMount() {
        document.title = 'Diagnostic Report'
        this.InitialLoading();
    };

    InitialLoading = () => {

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0))
            this.props.getAllCommunities();

        if (localStorage.getItem('superAdmin') === "false")
            this.getDining();

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (localStorage.getItem('communityId')) {

            this.GetCommunityDataByCommunityId(localStorage.getItem('communityId'));
            this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

        }

        this.SetHeaderButtons();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));

        this.props.SetHeaderButtons(undefined);
    };

    SetHeaderButtons = (open = false) => {
        const headerButtons = this.getHeaderButtons(open);
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = (open = false) => {
        const communityIdExist = !!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0);
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledDeleteButton: {
                backgroundColor: 'white'
            },
            disabledButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: 'white',
                color: '#686868 ',
                pointerEvents: 'none',
            },
            skyBlueButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                cursor: 'pointer',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                color: '#ffffff',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: '#009EDD',
            },
        }


        return (
            <Grid container style={styles.globalActions} >
                <Grid item container justifyContent='flex-end' alignItems='center' style={styles.globalActions}>

                    <Grid style={{ marginRight: "10px" }}
                        className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : "appbtnBarButtonv2 blueButton"}
                        disabled={!communityIdExist}
                        id='export_dinings_btn'
                        onClick={() => this.GetDiagnosticReportForCSVExport()}
                    >
                        Export to CSV
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    async GetCommunityDataByCommunityId(communityId, date) {
        let communityData = undefined;

        if (communityId) {
            communityData = await this.props.getCommunityByIdAsync(communityId);
            if (communityData[0].timeZoneName) {

                this.setState({ communityData: communityData });
            }
        }
        return communityData[0];
    };

    GetDiagnosticReportForCSVExport = () => {
        try {
            const communityInfo = this.state.superUserCommunitySelected;

            this.props.ExportDiagnostic(localStorage.getItem('communityId'), communityInfo.name, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        } catch (err) {
            return undefined
        }
    }


    resize() {
        this.setState({ isMobile: window.innerWidth <= 970 });
    };


    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    renderDiningType(type) {
        switch (type) {
            case 1:
                return "Breakfast";
            case 2:
                return "Lunch";
            case 3:
                return "Dinner";
            default:
                return "";
        }
    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    };

    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    };

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    };


    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                localStorage.setItem(key, value);
            }


            if (value && value.length > 0) {
                this.setState({
                    filtersObj: { ...initFilters, mealsSelected: [], tagsSelected: [] },
                    sortColumn: 'dateStart',
                    sortDesc: true,
                    filtersApplied: false,
                    searchValue: '',
                    openSearch: false,
                    currentPage: 0
                })

                this.props.GetAllDinings(value, this.state.currentPage);

            }
        } catch (err) { }
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet, selectAllButton: false, diningsSelected: [] }, () => this.SetHeaderButtons(false))
        } catch (err) { }
    };




    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };


    onFilterChange = (filterObj) => {
        const community = localStorage.getItem('communityId');

        if (filterObj) {
            this.setState({
                filterObj: filterObj,
                currentPage: 0,
                openFilters: false,
                AnchorElId: undefined
            }, () => {
                this.props.GetDiagnosticReportSort(community, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
            });
        }
    }

    handleSort = (column) => {

        const currentColumn = this.state.sortColumn;

        const updState = {
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage: 0,
            filtersApplied: true
        }

        if (currentColumn !== column) {
            updState.sortColumn = column
            updState.sortDesc = true;
        } else {
            updState.sortDesc = !this.state.sortDesc
        }

        this.setState(updState, async () => {
            await this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        });
    }

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome === 'true') ? true : false;
        if (shouldReturnToHome) {
            this.setState(
                {
                    open: false
                },
                () => {
                    this.InitialLoading();
                })
        }

        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);


        if ((!this.state.renderNedded) && this.state.communityData) {
            this.setState({ renderNedded: true });
        }

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin
            && this.props.communityData
            && this.props.communityData.length > 0
            && localStorage.getItem('communityId')
            && localStorage.getItem('communityId').length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserActivitiesLoaddedForCommunity ||
                    (this.state.superUserActivitiesLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserActivitiesLoaddedForCommunity !== undefined
            )
        ) {
            this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
            this.setState({ superUserActivitiesLoaddedForCommunity: this.state.superUserCommunitySelected });
        }

        const currentData = this.props.tableData && Array.isArray(this.props.tableData) ? this.props.tableData : [];
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        //Objeto que contiene los estilos declarados por useStyles
        const styles = {
            title: {
                flexGrow: 1
            },
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            }
        }

        return (
            <Grid item container xs={12}>
                <AppBar position="static" className="dark" style={{maxWidth: '95vw'}}>
                    <Toolbar>
                        <Grid item container xs={!this.state.open ? 4 : 12} sm={6} md={6} lg={6} alignContent='center' justifyContent='flex-start'>
                            <span id='dining_view_title' className="titleAppBar ToolbalCommunityName">
                                Diagnostic Report
                            </span>

                        </Grid>
                        <Grid container style={styles.globalActions} >
                            {

                                !this.state.open && !this.state.openAddLocation ?
                                    <Grid item xs={!this.state.open ? 12 : 1} sm={6} md={6} lg={6} container justifyContent='flex-end' alignContent='center' style={styles.globalActions}>
                                        {
                                            (isSuperAdmin && isSuperAdmin === true) ?
                                                <Grid item container xs={10} style={{ paddingLeft: '15px' }} justifyContent='center' alignContent='center' >
                                                    <SuperUserDropDown
                                                        stateOpen={this.state.open}
                                                        localStorageSetItem={this.localStorageSetItem}
                                                        localStorageRemoveItem={this.localStorageRemoveItem}
                                                        SetHeaderButtons={this.SetHeaderButtons}
                                                        handleCommunityCombo={this.handleCommunityCombo}
                                                        setState={this.setLocalState}
                                                        communityData={this.props.communityData}
                                                        superUserCommunitySelected={this.state.superUserCommunitySelected}
                                                        openCommunityCombo={this.state.openCommunityCombo}
                                                        handleCommunityOnBlur={this.handleCommunityOnBlur}
                                                    />
                                                </Grid>
                                                :
                                                undefined

                                        }

                                    </Grid>
                                    :
                                    undefined
                            }
                        </Grid>
                    </Toolbar>
                </AppBar>
                <main style={{ width: '100%' }}>
                    <div className="activityTitle-engage">
                        <form >
                            <div id="export_diagnostic_btn" style={{ display: 'none' }}
                                onClick={this.exportDiagnostic}>
                                Export
                            </div>
                            {
                                ///Device List
                                <Grid container className="activityTitle-engage" style={{ padding: '24px' }}>
                                    {/* Search and filters menu */}
                                    <Grid item container xs={12} justifyContent='flex-end' alignItems='center' style={{maxWidth: '90vw'}}>

                                        <IconButton item onClick={(e) => this.setState({ openFilters: true, AnchorElId: 'filters_diag_btn' })} id='filters_diag_btn'>
                                            <img
                                                src='https://engage360.s3.amazonaws.com/Icons/Categories/filter.svg'
                                                alt='filters_icon'
                                                width='30px'
                                                heigth='30px'
                                            />
                                        </IconButton>

                                    </Grid>
                                    <Grid container >
                                        <Grid container className='GridColumnTitle GridColumnTitleDiag' justifyContent='center' alignItems='center' style={{ flexGrow: 1, display: 'flex', flexWrap: 'nowrap', overflowX: 'auto'}} >
                                            <Grid item xs={12} style={{minWidth: '250px'}} id='addEditDevice_Headers_Resident'>
                                                Resident
                                                <IconButton onClick={() => this.handleSort('residentName')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'residentName' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'residentName' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'residentName') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '150px'}} id='addEditDevice_Headers_UnitNumber'>
                                                Unit Num
                                                <IconButton onClick={() => this.handleSort('unitNumber')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'unitNumber' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'unitNumber' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'unitNumber') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '190px'}} id='addEditDevice_Headers_MeasuringL'>
                                                Measuring L
                                                <IconButton onClick={() => this.handleSort('measuringLowestVal')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'measuringLowestVal' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'measuringLowestVal' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'measuringLowestVal') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '190px'}} id='addEditDevice_Headers_MeasuringH'>
                                                Measuring H
                                                <IconButton onClick={() => this.handleSort('measuringHighestVal')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'measuringHighestVal' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'measuringHighestVal' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'measuringHighestVal') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '160px'}} id='addEditDevice_Headers_Download'>
                                                Download
                                                <IconButton onClick={() => this.handleSort('downloadSpeedTest')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'downloadSpeedTest' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'downloadSpeedTest' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'downloadSpeedTest') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '160px'}} id='addEditDevice_Headers_Upload'>
                                                Upload
                                                <IconButton onClick={() => this.handleSort('uploadSpeedTest')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'uploadSpeedTest' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'uploadSpeedTest' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'uploadSpeedTest') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '200px'}} id='addEditDevice_Headers_Docsis'>
                                                DOCSIS
                                                <IconButton onClick={() => this.handleSort('docsis')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'docsis' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'docsis' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'docsis') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '200px'}} id='addEditDevice_Headers_macAddress'>
                                                MAC
                                                <IconButton onClick={() => this.handleSort('macAddress')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'macAddress' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'macAddress' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'macAddress') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '240px'}} id='addEditDevice_Headers_SerialNumber'>
                                                Serial
                                                <IconButton onClick={() => this.handleSort('serial')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'serial' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'serial' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'serial') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '200px'}} id='addEditDevice_Headers_AppVersion'>
                                                App Version
                                                <IconButton onClick={() => this.handleSort('appVersion')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'appVersion' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'appVersion' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'appVersion') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '150px'}} id='addEditDevice_Headers_Bluetooth'>
                                                Bluetooth
                                                <IconButton onClick={() => this.handleSort('bluetooth')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'bluetooth' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'bluetooth' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'bluetooth') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '280px'}} id='addEditDevice_Headers_RemotePairedName'>
                                                Remote Paired Name
                                                <IconButton onClick={() => this.handleSort('remotePairedName')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'remotePairedName' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'remotePairedName' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'remotePairedName') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '350px'}} id='addEditDevice_Headers_RemoteFirstPairedDate'>
                                                Remote First Paired Date
                                                <IconButton onClick={() => this.handleSort('remoteFirstPairedDate')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'remoteFirstPairedDate' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'remoteFirstPairedDate' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'remoteFirstPairedDate') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={12} style={{minWidth: '200px'}} id='addEditDevice_Headers_RemoteMAC'>
                                                Remote MAC
                                                <IconButton onClick={() => this.handleSort('remoteMacAddress')}>
                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'remoteMacAddress' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'remoteMacAddress' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'remoteMacAddress') ? faSort : null} color='#a2a1a2' />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                        <Grid container  >
                                            {
                                                currentData.map((item, index) => {
                                                    if (currentData.length === index + 1) { /* We call the reference in the last row */
                                                        return (
                                                            <Grid item container ref={this.lastDiagnosticRef} key={index} className='rowEngageStyleList' alignContent='center' style={{ backgroundColor: '#1f1f1f', borderRadius: '4px', marginTop: '6px', textAlign: 'center' }}>
                                                                <Grid item container className="rowEngageStyle" justifyContent='center' alignContent='center' style={{ alignItems: 'center', display: 'flex', width: '250px'}} >
                                                                    <Grid item style={{ paddingLeft: '15px'}}>
                                                                        {item.residentName}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '150px' }}>
                                                                    <Grid item>
                                                                        {item.unitNumber}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '190px'}}>
                                                                    <Grid item>
                                                                        {item.measuringLowestVal} dB
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '190px'}}>
                                                                    <Grid item>
                                                                        {item.measuringHighestVal} dB
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '160px' }}>
                                                                    <Grid item>
                                                                        {item.downloadSpeedTest} Mbps
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '160px' }}>
                                                                    <Grid item>
                                                                        {item.uploadSpeedTest} Mbps
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '2000px' }}>
                                                                    <Grid item>
                                                                        {item.docsis}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.macAddress}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '240px' }}>
                                                                    <Grid item>
                                                                        {item.serial}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.appVersion}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '150px' }}>
                                                                    <Grid item>
                                                                        {item.bluetooth}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '280px' }}>
                                                                    <Grid item>
                                                                        {item.remotePairedName}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '350px' }}>
                                                                    <Grid item>
                                                                        {item.remoteFirstPairedDate}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.remoteMacAddress}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    } else {
                                                        return (
                                                            <Grid item container key={index} className='rowEngageStyleList' alignContent='center' style={{ backgroundColor: '#1f1f1f', borderRadius: '4px', marginTop: '6px', textAlign: 'center' }}>
                                                                <Grid item container className="rowEngageStyle" justifyContent='center' alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', width: '250px'}}>
                                                                    <Grid item style={{ paddingLeft: '15px'}}>
                                                                        {item.residentName}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '150px'}}>
                                                                    <Grid item>
                                                                        {item.unitNumber}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '190px'}}>
                                                                    <Grid item>
                                                                        {item.measuringLowestVal} dB
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '190px'}}>
                                                                    <Grid item>
                                                                        {item.measuringHighestVal} dB
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '160px' }}>
                                                                    <Grid item>
                                                                        {item.downloadSpeedTest} Mbps
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '160px' }}>
                                                                    <Grid item>
                                                                        {item.uploadSpeedTest} Mbps
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.docsis}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.macAddress}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '240px' }}>
                                                                    <Grid item>
                                                                        {item.serial}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.appVersion}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '150px' }}>
                                                                    <Grid item>
                                                                        {item.bluetooth}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '280px' }}>
                                                                    <Grid item>
                                                                        {item.remotePairedName}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '350px' }}>
                                                                    <Grid item>
                                                                        {item.remoteFirstPairedDate}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container className="rowEngageStyle" alignContent='center' justifyContent='center' style={{ width: '200px' }}>
                                                                    <Grid item>
                                                                        {item.remoteMacAddress}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    }
                                                })
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }

                        </form>

                        {/* FILTERS MODAL */}
                        {
                            this.state.openFilters && this.state.AnchorElId ?
                                <DiagnosticFiltersDrawer
                                    idAnchorEl={this.state.AnchorElId}
                                    onClose={() => this.setState({ openFilters: false, AnchorElId: undefined })}
                                    onFilterChange={this.onFilterChange}
                                    isLegacy={true}
                                    newStyles={true}
                                    filterObj={this.state.filterObj ? this.state.filterObj : {}}
                                />
                                :
                                undefined
                        }

                    </div>

                </main>
            </Grid>      
        )
    }
}

function mapStateToProps(state, dispatch) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, timeZoneName: item.timeZoneName })) : [];
    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome) ? state.currentUrlReducer.returnToHome : 'false';
    const diagnosticData = (state.diagnosticReportReducer && state.diagnosticReportReducer.diagnosticData) ? [...state.diagnosticReportReducer.diagnosticData] : [];
    const total = (state.diagnosticReportReducer && state.diagnosticReportReducer.totalReports) ? state.diagnosticReportReducer.totalReports : 0;

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        communityData: communityData,
        tableData: diagnosticData,
        total,
        returnToHome: returnToHome
    }
}

DiagnosticReport = reduxForm({
    form: 'DeviceForm',
    // validate,
    enableReinitialize: true,
})(DiagnosticReport);

export default connect(mapStateToProps,
    {
        getCommunityByIdAsync,
        SetHeaderButtons,
        getAllCommunities,
        GetDiagnosticReportSort,
        ExportDiagnostic
    })(DiagnosticReport);